import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Sparkles, Crown, Shield } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function TopBar({ subtitle }) {
  const { user } = useAuth();
  return (
    <header data-testid="top-bar" className="sticky top-0 z-30 glass border-b border-zinc-800/80">
      <div className="max-w-2xl mx-auto flex items-center justify-between px-4 h-14">
        <Link to="/app" className="flex items-center gap-2">
          <Logo />
          {subtitle && <span className="text-zinc-400 text-xs hidden sm:inline">/ {subtitle}</span>}
        </Link>
        {user && (
          <div className="flex items-center gap-2">
            {user.is_admin && (
              <Link to="/app/admin" data-testid="topbar-admin-btn" className="flex items-center gap-1 text-xs px-2.5 py-1 rounded-full bg-gradient-to-r from-[#DC2626] to-[#7F1D1D] text-white font-semibold border border-[#DC2626]/60 shadow-md shadow-[#DC2626]/20 hover:brightness-110 transition">
                <Shield size={12}/> Admin
              </Link>
            )}
            {user.plan !== "free" ? (
              <span data-testid="plan-badge" className="flex items-center gap-1 text-xs px-2.5 py-1 rounded-full bg-[#DC2626]/15 text-[#DC2626] border border-[#DC2626]/30">
                <Crown size={12}/> {user.plan.toUpperCase()}
              </span>
            ) : (
              <Link to="/app/plans" data-testid="upgrade-btn" className="flex items-center gap-1 text-xs px-2.5 py-1 rounded-full bg-zinc-900 text-zinc-300 border border-zinc-800 hover:border-[#DC2626]/40 transition-colors">
                <Sparkles size={12}/> Upgrade
              </Link>
            )}
          </div>
        )}
        {!user && (
          <div className="flex items-center gap-2">
            <Link to="/login" data-testid="topbar-login-btn" className="text-xs px-3 py-1 rounded-full bg-zinc-900 text-zinc-200 border border-zinc-800 hover:border-[#DC2626]/40 transition-colors">Log in</Link>
            <Link to="/signup" data-testid="topbar-signup-btn" className="text-xs px-3 py-1 rounded-full bg-[#DC2626] hover:bg-[#EF4444] text-white font-semibold transition-colors">Sign up</Link>
          </div>
        )}
      </div>
    </header>
  );
}
